export default function familiarize(fullName) {
  let name = fullName.split(" ")[0];
  return name;
}
